import { countries } from './Countries'

class LindbergDealersGeolocation extends HTMLElement {

	connectedCallback() {
		if(!navigator.geolocation) return	
		navigator.geolocation.getCurrentPosition((position) => this.setLocation(position), error => console.error('Geolocation error:', error))
	}
	
	async setLocation(position:GeolocationPosition) {
		const coords = position.coords
		
		const result = await (await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${coords.longitude},${coords.latitude}.json?${new URLSearchParams({ language: 'en', types: 'country', limit: '1', access_token: import.meta.env.VITE_MAPBOX_TOKEN }).toString()}`)).json()
		console.log(result)
		const country = countries.find(x => x.code === result.features[0].properties.short_code.toUpperCase())
		console.log('Geolocation result:', result, country)
		if (country) { 
			this.dispatchEvent(new CustomEvent('country-selected', { bubbles: true, detail: { country } }))
		}
	}
}

customElements.define('lindberg-dealers-geolocation', LindbergDealersGeolocation)
